import { defineComponent, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock } from 'vue';
import { OrIcon as script$1 } from '../or-icon/index.js';
import { s as styleInject } from '../../style-inject.es-87955792.js';
import '../or-tooltip/index.js';
import 'lodash/isNil';
import '../or-tooltip/or-tooltip-content/index.js';
import '../or-floating/index.js';
import '@floating-ui/dom';
import '../or-teleport/index.js';
import '../../dom-11141778.js';
import 'lodash/get';
import 'lodash/isElement';
import '../../px-to-rem-a21cdf39.js';

var OR_AVATAR_SIZE;
(function (OR_AVATAR_SIZE) {
  OR_AVATAR_SIZE["SMALL"] = "small";
  OR_AVATAR_SIZE["MEDIUM"] = "medium";
  OR_AVATAR_SIZE["LARGE"] = "large";
})(OR_AVATAR_SIZE || (OR_AVATAR_SIZE = {}));

var script = defineComponent({
  name: 'OrAvatar',
  components: {
    OrIcon: script$1
  },
  props: {
    src: {
      type: String,
      default: '',
      required: false
    },
    size: {
      type: String,
      default: () => OR_AVATAR_SIZE.MEDIUM,
      required: false
    },
    icon: {
      type: String,
      default: 'account_circle',
      required: false
    }
  },
  data(props) {
    return {
      showImg: !!props.src
    };
  },
  computed: {
    avatarClasses() {
      return ['or-avatar', {
        [`is-${this.size}-size`]: !!this.size
      }];
    }
  },
  watch: {
    src(val) {
      this.showImg = !!val;
    }
  },
  methods: {
    showImage() {
      this.showImg = true;
    },
    hideImage() {
      this.showImg = false;
    }
  }
});

const _hoisted_1 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.avatarClasses)
  }, [_ctx.showImg ? (openBlock(), createElementBlock("img", {
    key: 0,
    src: _ctx.src,
    class: "image",
    alt: "avatar",
    onLoad: _cache[0] || (_cache[0] = (...args) => _ctx.showImage && _ctx.showImage(...args)),
    onError: _cache[1] || (_cache[1] = (...args) => _ctx.hideImage && _ctx.hideImage(...args))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)) : (openBlock(), createBlock(_component_or_icon, {
    key: 1,
    icon: _ctx.icon
  }, null, 8 /* PROPS */, ["icon"]))], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-ed355150 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-ed355150 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-avatar[data-v-ed355150], .or-avatar > .image[data-v-ed355150] {\n  border-radius: 9999px;\n  object-fit: cover;\n}\n.or-avatar.is-small-size[data-v-ed355150], .or-avatar.is-small-size > .image[data-v-ed355150] {\n  width: 32px;\n  height: 32px;\n}\n.or-avatar.is-small-size[data-v-ed355150] .or-icon {\n  font-size: 2rem;\n  line-height: 2rem;\n}\n.or-avatar.is-medium-size[data-v-ed355150], .or-avatar.is-medium-size > .image[data-v-ed355150] {\n  width: 40px;\n  height: 40px;\n}\n.or-avatar.is-medium-size[data-v-ed355150] .or-icon {\n  font-size: 2.5rem;\n  line-height: 2.5rem;\n}\n.or-avatar.is-large-size[data-v-ed355150], .or-avatar.is-large-size > .image[data-v-ed355150] {\n  width: 80px;\n  height: 80px;\n}\n.or-avatar.is-large-size[data-v-ed355150] .or-icon {\n  font-size: 5rem;\n  line-height: 5rem;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-ed355150";
script.__file = "src/components/or-avatar/OrAvatar.vue";

export { OR_AVATAR_SIZE, script as OrAvatar };
